import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { TextureLoader } from "./TextureLoader.js";
import { throwWarning } from "../utils/utils.js";
/*** PLANE TEXTURE LOADER CLASS ***/

/***
 Extends our TextureLoader class to add sources loaded count, handle onComplete event
 Also adds the sources and textures to its defined parent

 params:
 @renderer (Curtains renderer or Renderer class object): our curtains object OR our curtains renderer object
 @parent (Plane or ShaderPass class object): The plane or shader pass that will use this loader

 @sourcesLoaded (int): Number of sources loaded
 @sourcesToLoad (int): Number of initial sources to load
 @complete (bool): Whether the loader has loaded all the initial sources
 @onComplete (function): Callback to execute when all the initial sources have been loaded

 returns :
 @this: our PlaneTextureLoader element
 ***/

export var PlaneTextureLoader = /*#__PURE__*/function (_TextureLoader) {
  _inherits(PlaneTextureLoader, _TextureLoader);

  var _super = _createSuper(PlaneTextureLoader);

  function PlaneTextureLoader(renderer, parent) {
    var _this;

    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$sourcesLoaded = _ref.sourcesLoaded,
        sourcesLoaded = _ref$sourcesLoaded === void 0 ? 0 : _ref$sourcesLoaded,
        _ref$sourcesToLoad = _ref.sourcesToLoad,
        sourcesToLoad = _ref$sourcesToLoad === void 0 ? 0 : _ref$sourcesToLoad,
        _ref$complete = _ref.complete,
        complete = _ref$complete === void 0 ? false : _ref$complete,
        _ref$onComplete = _ref.onComplete,
        onComplete = _ref$onComplete === void 0 ? function () {} : _ref$onComplete;

    _classCallCheck(this, PlaneTextureLoader);

    _this = _super.call(this, renderer, parent.crossOrigin);
    _this.type = "PlaneTextureLoader";
    _this._parent = parent;

    if (_this._parent.type !== "Plane" && _this._parent.type !== "PingPongPlane" && _this._parent.type !== "ShaderPass") {
      throwWarning(_this.type + ": Wrong parent type assigned to this loader");
      _this._parent = null;
    }

    _this.sourcesLoaded = sourcesLoaded;
    _this.sourcesToLoad = sourcesToLoad;
    _this.complete = complete;
    _this.onComplete = onComplete;
    return _this;
  }
  /*** TRACK LOADING ***/

  /***
   Sets the total number of assets to load before firing the onComplete event
     params:
   @size (int): our curtains object OR our curtains renderer object
   ***/


  _createClass(PlaneTextureLoader, [{
    key: "_setLoaderSize",
    value: function _setLoaderSize(size) {
      var _this2 = this;

      this.sourcesToLoad = size;

      if (this.sourcesToLoad === 0) {
        this.complete = true;
        this.renderer.nextRender.add(function () {
          return _this2.onComplete && _this2.onComplete();
        });
      }
    }
    /***
     Increment the number of sources loaded
     ***/

  }, {
    key: "_increment",
    value: function _increment() {
      var _this3 = this;

      this.sourcesLoaded++;

      if (this.sourcesLoaded >= this.sourcesToLoad && !this.complete) {
        this.complete = true;
        this.renderer.nextRender.add(function () {
          return _this3.onComplete && _this3.onComplete();
        });
      }
    }
    /*** UPDATE PARENT SOURCES AND TEXTURES ARAYS ***/

    /***
     Adds the source to the correct parent assets array
       params:
     @source (html element): html image, video or canvas element that has been loaded
     @sourceType (string): either "image", "video" or "canvas"
     ***/

  }, {
    key: "_addSourceToParent",
    value: function _addSourceToParent(source, sourceType) {
      // add the source if it is not already in the correct parent assets array
      if (sourceType === "image") {
        var parentAssetArray = this._parent["images"];
        var isInParent = parentAssetArray.find(function (element) {
          return element.src === source.src;
        });
        !isInParent && parentAssetArray.push(source);
      } else if (sourceType === "video") {
        var _parentAssetArray = this._parent["videos"];

        var _isInParent = _parentAssetArray.find(function (element) {
          return element.src === source.src;
        });

        !_isInParent && _parentAssetArray.push(source);
      } else if (sourceType === "canvas") {
        var _parentAssetArray2 = this._parent["canvases"];

        var _isInParent2 = _parentAssetArray2.find(function (element) {
          return element.isSameNode(source);
        });

        !_isInParent2 && _parentAssetArray2.push(source);
      }
    }
    /***
     Adds the loader parent to the newly created texture
     Also adds the source to the correct parent assets array
       params:
     @texture (Texture class object): our newly created texture
     @source (html element): html image, video or canvas element that has been loaded
     @sourceType (string): either "image", "video" or "canvas"
     ***/

  }, {
    key: "_addToParent",
    value: function _addToParent(texture, source, sourceType) {
      this._addSourceToParent(source, sourceType); // add the texture to the parent


      this._parent && texture.addParent(this._parent);
    }
  }]);

  return PlaneTextureLoader;
}(TextureLoader);